import {buildQueryStringFromParams} from './url'

export const dashboardPageUrl = '/dashboard'

export const loginPageUrl = '/pages/login'

export function storeTokenParams(params) {
  localStorage.setItem('access_token', params.access_token);
  localStorage.setItem('refresh_token', params.refresh_token);

  var date = new Date();
  date.setSeconds(date.getSeconds() + params.expires_in - 300); // minus 5 minutes margin
  localStorage.setItem('expiration_date', date.getTime());
}

export function clearStoredTokenParams() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expiration_date');
}

export function isTokenExpired() {
  var currentDate = new Date().getTime();

  return currentDate > localStorage.getItem('expiration_date');
}

export function buildQueryStringForGettingTokenFromProvider(providerName, authCode) {
  var params = {
    grant_type: 'password',
    external_provider_name: providerName,
    external_authorization_code: authCode,
    external_redirect_uri: process.env.REACT_APP_MS_LOGIN_REDIRECT_URI,
    client_id: process.env.REACT_APP_TOKEN_CLIENT_ID
  }

  return buildQueryStringFromParams(params);
}

export function buildQueryStringForRefreshingToken() {
  if (!localStorage.getItem('refresh_token')){
    return null;
  }

  var params = {
    grant_type: 'refresh_token',
    refresh_token: localStorage.getItem('refresh_token'),
    client_id: process.env.REACT_APP_TOKEN_CLIENT_ID
  }

  return buildQueryStringFromParams(params);
}
